import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

/**
 * Busca modelos de prescrição (QuestionnaireResponse) do servidor FHIR
 *
 * @param organizationId - ID da organização (author)
 * @param id - ID específico do modelo (opcional)
 * @returns Bundle com os QuestionnaireResponse encontrados
 */
export async function GetPrescriptionTemplates({
  organizationId,
  id,
}: {
  organizationId: string;
  id?: string;
}) {
  // URL base com filtros
  let url = `${endpoints.ADMFHIR}/QuestionnaireResponse?questionnaire=${endpoints.PROTOCOL_ID}&author=Organization/${organizationId}&_sort=-_lastUpdated&_count=200`;

  // Se especificou ID, adiciona filtro
  if (id) {
    url = `${url}&_id=${id}`;
  }

  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetPrescriptionTemplates: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetPrescriptionTemplates Error:", error);
      throw new Error(
        `Erro ao buscar modelos: ${error?.response?.status || "Desconhecido"}`
      );
    });

  return response;
}
